import { render } from "./ReadQuestions.vue?vue&type=template&id=0277c593&scoped=true&ts=true"
import script from "./ReadQuestions.vue?vue&type=script&lang=ts"
export * from "./ReadQuestions.vue?vue&type=script&lang=ts"

import "./ReadQuestions.vue?vue&type=style&index=0&id=0277c593&scoped=true&lang=postcss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0277c593"]])

export default __exports__